import PersonalDetailsScreen from 'features/personalDetails/screens/PersonalDetailsScreen';
import React from 'react';

export default function MyPersonalDetailsScreen() {
  return <PersonalDetailsScreen />;
}
